const skillsInfo =[ 
    {
       title: "Core Competencies: ",
       title2: "Programming Languages:",
       title3: "Libraries: ",
       title4: "Dev/ Build Platforms:",
       title5: "Topics of interest:",
       skillList: "C/C++, Python",
       libraries: "opencv, opengl, openvino, IMGUI, tensorRT, tensorflow, pytorch, onnx runtime, scikit learn, pyqt",
       devPlatforms: "windows, linux / ubuntu, cmake, git, visual studio", 
       researchArea: "ROS, 3D computer vision, deep learning, machine learning, Stereo Camera, image processing, AI deployment on edge, Graphics programming, signal processing, sensor fusion"
    }, 

    {
        title: "Additional Skills",
        skillList: "React, Javascript, Three.js , Two.js, HTML / CSS"
     },



] ;
export default skillsInfo;